import * as PropertyBucket from '../../Properties/Properties.js';
import * as httpService from '../../Components/HttpService/HttpService';

export function getUsersDataRequested() {
    return {
        type: 'GET_USERS_DATA_REQUESTED'
    };
}

export function getUsersDataDone(data) {
    return {
        type: 'GET_USERS_DATA_DONE',
        payload: data
    };
}

export function getUsersDataFailed(error) {
    return {
        type: 'GET_USERS_DATA_FAILED',
        payload: error
    };
}

export function getUsersData() {
    let url = PropertyBucket.getUserInfo();
    return dispatch => {
        dispatch(getUsersDataRequested());
        let response = httpService.getService(url, "GET");
        response.then(data => {
            if ((localStorage.getItem('user') !== `${data.userFirstName} ${data.userSurname}`) || (localStorage.getItem('userLogin') !== data.login)) {
                localStorage.removeItem('programs');
                localStorage.removeItem('selectedProgram');
            }
            dispatch(getUsersDataDone(data.users));
        })
            .catch(error => {
                dispatch(getUsersDataFailed(error));
            })
    }
}

export function getControllersUsersData() {
    let url = PropertyBucket.getControllersUsers();
    return dispatch => {
        dispatch(getUsersDataRequested());
        let response = httpService.getService(url, "GET");
        response.then(data => {
            dispatch(getUsersDataDone(data.users));
        })
            .catch(error => {
                dispatch(getUsersDataFailed(error));
            })
    }
}

export const GET_USERS_DATA_REQUESTED = 'GET_USERS_DATA_REQUESTED';
export const GET_USERS_DATA_DONE = 'GET_USERS_DATA_DONE';
export const GET_USERS_DATA_FAILED = 'GET_USERS_DATA_FAILED';